import { FiFileText, FiPaperclip } from 'react-icons/fi';
import { getAttachmentName, isPdfAttachment } from '../../utils/attachments';
import { AuthenticatedAttachmentImage } from '../../hooks/useAuthenticatedAttachmentUrl';
import { AppTooltip } from '../ui/AppTooltip';

const MAX_VISIBLE_ATTACHMENTS = 3;

export const AttachmentThumbnails = ({ attachments = [], onOpen, t }) => {
  const files = attachments.filter(Boolean);
  if (!files.length) {
    return (
      <span className='inline-flex items-center gap-1.5 whitespace-nowrap text-[var(--text-muted)]'>
        <FiPaperclip className='h-4 w-4' aria-hidden='true' />
        {t('No attachments')}
      </span>
    );
  }

  const visibleFiles = files.slice(0, MAX_VISIBLE_ATTACHMENTS);
  const remaining = files.length - visibleFiles.length;

  return (
    <div className='flex min-w-0 flex-nowrap items-center gap-1.5' aria-label={t('Attachments')}>
      {visibleFiles.map((attachment, index) => (
        <AppTooltip key={`${attachment}-${index}`} label={getAttachmentName(attachment)}><button
          type='button'
          onClick={() => onOpen(files, index)}
          className='group relative flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-[var(--radius-md)] border border-[var(--border-subtle)] bg-[var(--surface-panel-muted)] shadow-sm hover:border-[var(--brand)] hover:shadow-md'
          aria-label={`${t('Open attachment')} ${index + 1}: ${getAttachmentName(attachment)}`}
        >
          {isPdfAttachment(attachment) ? (
            <FiFileText className='h-5 w-5 text-[var(--danger)]' aria-hidden='true' />
          ) : (
            <AuthenticatedAttachmentImage
              attachment={attachment}
              alt=''
              loading='lazy'
              className='h-full w-full object-cover transition-transform duration-200 group-hover:scale-105'
            />
          )}
          <span className='absolute inset-0 bg-slate-950/0 transition-colors group-hover:bg-slate-950/10' aria-hidden='true' />
        </button></AppTooltip>
      ))}

      {remaining > 0 && (
        <AppTooltip label={`${remaining} ${t('More attachments')}`}><button
          type='button'
          onClick={() => onOpen(files, MAX_VISIBLE_ATTACHMENTS)}
          className='flex h-10 min-w-10 shrink-0 items-center justify-center rounded-[var(--radius-md)] border border-[var(--border-subtle)] bg-[var(--surface-panel-muted)] px-2 text-xs font-bold text-[var(--text-secondary)] shadow-sm hover:border-[var(--brand)] hover:text-[var(--brand-strong)]'
          aria-label={`${remaining} ${t('More attachments')}`}
        >
          +{remaining}
        </button></AppTooltip>
      )}
    </div>
  );
};

export { MAX_VISIBLE_ATTACHMENTS };
